<template>
  <div>
    <div class="row">
      <div v-if="news" class="col-xs-12 well" :class="testInBoxes() ? 'docInBiblio' : ''">
        <news-action :key="'action-' + news.biblio" :news="news" :context="context" :biblioBoxes="biblioBoxes"></news-action>
        <div class="clearfix"></div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Title : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">
            <span v-html="news.name"></span>
          </div>
        </div>
        <div class="row" style="padding-top: 10px">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Provider : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">
            <span v-html="news.provider[0].name" v-if="news.provider && news.provider[0]"></span> <span> ({{ news.datePublished| moment('DD/MM/YYYY')}})</span>
          </div>
        </div>

        <div class="row" style="padding-top: 15px">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Abstract : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8" v-if="news.description">
            <span v-html="news.description"></span>
          </div>
        </div>
        <div class="row" style="padding-top: 15px" v-if="news.category">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>category : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8" v-if="news.category">
            <span v-html="news.category"></span>
          </div>
        </div>
        <div class="row" style="padding-top: 15px">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>URL : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8">
            <a :href="news.url" target="_blank">{{news.url}}</a>
          </div>
        </div>
        <div class="row" style="padding-top: 15px" v-if="news.image">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>image : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8">
            <img :src="news.image.thumbnail.contentUrl" :alt="news.image.thumbnail.name">
            <span v-html="news.image.thumbnail.name"></span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
  .item-label {
    font-weight: bold;
  }

  .docInBiblio{
    border-left: thick solid #3498db;
  }
</style>
<script>

import NewsAction from './NewsAction'

export default {
  name: 'DocumentNews',
  components: {NewsAction},
  props: ['value', 'context', 'biblioBoxes'],
  watch: {
    value: function (val) {
      this.news = val
    }
  },
  data () {
    return {
      news: []
    }
  },
  methods: {
    testInBoxes: function () {
      if (this.value.biblio) {
        return true
      }
      return false
    }
  },
  beforeMount () {
    this.news = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentNews.vue